<div *ngIf="changeRequestVO">
  <div class="page-header">
    <div class="grid-container"> {{changeRequestVO.id}} </div>
  </div>
  <div class="grid-container">
  <div style="display: flex; align-items: baseline">
    <div class="cr-status">{{changeRequestVO.statusName}}</div>
    <div class="header-helper" style="font-style: italic">&nbsp;&nbsp;Since {{changeRequestVO.lastStatusUpate | commonDate}}</div>
  </div>
  <div class="content-header"> Domain: {{changeRequestVO.tldName}}</div>
  <div class="header-helper" [innerText]="changeRequestVO.statusDescription"></div>
  </div>
</div>
<div *ngIf="changeRequestID">
  <div class="page-header">
    <div class="grid-container"> {{changeRequestID}} </div>
  </div>
</div>
